angular.module('impactx').config([
    '$mdThemingProvider',
    '$configProvider',
    function ($mdThemingProvider, $configProvider) {
        var companyThemeConfigs = [];

        function getConfig(configObj, propertyName, fallbackFnOrObject) {
            if(configObj && typeof configObj === 'object' && typeof configObj[propertyName] === 'object') {
                return configObj[propertyName];
            }
            if(typeof fallbackFnOrObject === 'function') {
                return fallbackFnOrObject()[propertyName];
            }
            return fallbackFnOrObject[propertyName];
        }

        function getAccentConfig(configObj, fallbackFn) {
            return getConfig(configObj, 'accent', fallbackFn);
        }

        function getPrimaryConfig(configObj, fallbackFn) {
            return getConfig(configObj, 'primary', fallbackFn);
        }

        function getBothThemeConfigs(configObj, fallbackFn) {
            return {
                accent:getAccentConfig(configObj, fallbackFn),
                primary:getPrimaryConfig(configObj, fallbackFn)
            };
        }


        var shopThemeConfig = impactX.isDefined(window, 'themeConfig.shop');
        $mdThemingProvider.definePalette('shopPrimary', getPrimaryConfig(shopThemeConfig,getShopPalette));
        $mdThemingProvider.definePalette('shopAccent', getAccentConfig(shopThemeConfig, getShopPalette));

        var contentThemeConfig = impactX.isDefined(window, 'themeConfig.content');
        $mdThemingProvider.definePalette('contentPrimary', contentThemeConfig ? contentThemeConfig.primary : getContentPalette().primary);
        $mdThemingProvider.definePalette('contentAccent', contentThemeConfig ? contentThemeConfig.accent : getContentPalette().accent);

        var monitorThemeConfig = impactX.isDefined(window, 'themeConfig.monitor');
        $mdThemingProvider.definePalette('monitorPrimary', monitorThemeConfig ? monitorThemeConfig.primary : getMonitorPalette().primary);
        $mdThemingProvider.definePalette('monitorAccent', monitorThemeConfig ? monitorThemeConfig.accent : getMonitorPalette().accent);

        var adminThemeConfig = impactX.isDefined(window, 'themeConfig.admin');
        $mdThemingProvider.definePalette('adminPrimary', adminThemeConfig ? adminThemeConfig.primary : getAdminPalette().primary);
        $mdThemingProvider.definePalette('adminAccent', adminThemeConfig ? adminThemeConfig.accent : getAdminPalette().accent);

        var systemThemeConfig = impactX.isDefined(window, 'themeConfig.system');
        $mdThemingProvider.definePalette('systemPrimary', systemThemeConfig ? systemThemeConfig.primary : getSystemPalette().primary);
        $mdThemingProvider.definePalette('systemAccent', systemThemeConfig ? systemThemeConfig.accent : getSystemPalette().accent);

        var highContrastThemeConfig = impactX.isDefined(window, 'themeConfig.highContrast');
        $mdThemingProvider.definePalette('highContrastPrimary', highContrastThemeConfig ? highContrastThemeConfig.primary : getHighContrastPalette().primary);
        $mdThemingProvider.definePalette('highContrastAccent', highContrastThemeConfig ? highContrastThemeConfig.accent : getHighContrastPalette().accent);

        addTheme('shop', 'shopPrimary', 'shopAccent', 'warnPalette');
        addTheme('content', 'contentPrimary', 'contentAccent', 'warnPalette');
        addTheme('monitor', 'monitorPrimary', 'monitorAccent', 'warnPalette');
        addTheme('admin', 'adminPrimary', 'adminAccent', 'warnPalette');
        addTheme('system', 'systemPrimary', 'systemAccent', 'warnPalette');
        addTheme('highContrast', 'highContrastPrimary', 'highContrastAccent', 'warnPalette');

        if (impactX.isDefined(window, 'themeConfig.comIds')) {
            var adminConfigPair, contentConfigPair, monitorConfigPair, shopConfigPair, systemConfigPair;

            for (var i = 0; i < window.themeConfig.comIds.length; i++) {
                var comId = window.themeConfig.comIds[i];

                shopThemeConfig = impactX.isDefined(window, 'themeConfig.shop' + comId);
                shopConfigPair = getBothThemeConfigs(shopThemeConfig, getShopPalette);
                $mdThemingProvider.definePalette('shop' + comId + 'Primary', shopConfigPair.primary);
                $mdThemingProvider.definePalette('shop' + comId + 'Accent', shopConfigPair.accent);

                contentThemeConfig = impactX.isDefined(window, 'themeConfig.content' + comId);
                contentConfigPair = getBothThemeConfigs(contentThemeConfig, getContentPalette);
                $mdThemingProvider.definePalette('content' + comId + 'Primary', contentConfigPair.primary);
                $mdThemingProvider.definePalette('content' + comId + 'Accent', contentConfigPair.accent);

                monitorThemeConfig = impactX.isDefined(window, 'themeConfig.monitor' + comId);
                monitorConfigPair = getBothThemeConfigs(monitorThemeConfig, getMonitorPalette);
                $mdThemingProvider.definePalette('monitor' + comId + 'Primary', monitorConfigPair.primary);
                $mdThemingProvider.definePalette('monitor' + comId + 'Accent', monitorConfigPair.accent);

                adminThemeConfig = impactX.isDefined(window, 'themeConfig.admin' + comId);
                adminConfigPair = getBothThemeConfigs(adminThemeConfig, getAdminPalette);
                $mdThemingProvider.definePalette('admin' + comId + 'Primary', adminConfigPair.primary);
                $mdThemingProvider.definePalette('admin' + comId + 'Accent', adminConfigPair.accent);

                systemThemeConfig = impactX.isDefined(window, 'themeConfig.system' + comId);
                systemConfigPair = getBothThemeConfigs(systemThemeConfig, getSystemPalette);
                $mdThemingProvider.definePalette('system' + comId + 'Primary', systemConfigPair.primary);
                $mdThemingProvider.definePalette('system' + comId + 'Accent', systemConfigPair.accent);

                addTheme('shop' + comId, 'shop' + comId + 'Primary', 'shop' + comId + 'Accent', 'warnPalette');
                addTheme('content' + comId, 'content' + comId + 'Primary', 'content' + comId + 'Accent', 'warnPalette');
                addTheme('monitor' + comId, 'monitor' + comId + 'Primary', 'monitor' + comId + 'Accent', 'warnPalette');
                addTheme('admin' + comId, 'admin' + comId + 'Primary', 'admin' + comId + 'Accent', 'warnPalette');
                addTheme('system' + comId, 'system' + comId + 'Primary', 'system' + comId + 'Accent', 'warnPalette');

                // For Angular
                companyThemeConfigs.push(
                    angular.copy({
                        comId: comId,
                        themeConfig: {
                            admin: adminConfigPair,
                            content: contentConfigPair,
                            monitor: monitorConfigPair,
                            shop: shopConfigPair,
                            system: systemConfigPair
                        }
                    })
                );
            }
        }

        $mdThemingProvider.alwaysWatchTheme(true);
        $mdThemingProvider.generateThemesOnDemand(true);
        $mdThemingProvider.theme('default').accentPalette('shopAccent');

        function addTheme(theme, palette, accentPalette, warnPalette) {
            $configProvider.defaultThemes.push(theme);
            $configProvider.configuredThemes.push(theme);
            $mdThemingProvider.theme(theme)
                .primaryPalette(palette)
                .accentPalette(accentPalette)
                .warnPalette(warnPalette)
                .backgroundPalette('backgroundPalette');
        }

        function getBackgroundPalette() {
            return {
                '50': '#f0f0f0', <!-- header card background -->
                '100': '#f5f5f5', <!-- List header -->
                '200': '#eeeeee', <!-- Content background -->
                '300': '#e0e0e0', <!-- Readonly Checkbox mark -->
                '400': '#bdbdbd',  <!-- Hover for buttons/autocompletes -->
                '500': '#9e9e9e',
                '600': '#757575',
                '700': '#616161',
                '800': '#424242',
                '900': '#212121',
                'A100': '#ffffff', <!-- PRIMARY BACKGROUND, color for sidebars, some cards for some reason -->
                'A200': '#000000',
                'A400': '#303030',
                'A700': '#616161',
                'contrastDefaultColor': 'dark',
                'contrastLightColors': '600 700 800 900 A200 A400 A700'
            };
        }

        $mdThemingProvider.definePalette('backgroundPalette', getBackgroundPalette());

        function getWarnPalette() {
            return  {
                '50': '#fae4e0',
                '100': '#f2bcb3',
                '200': '#ea9080',
                '300': '#e1644d',
                '400': '#da4226',
                '500': '#d42100',
                '600': '#cf1d00',
                '700': '#c91800',
                '800': '#c31400',
                '900': '#b90b00',
                'A100': '#d42100',
                'A200': '#d42100',
                'A400': '#d42100',
                'A700': '#d42100',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': [
                    '50',
                    '100',
                    '200',
                    '300',
                    'A100',
                    'A200',
    
                ],
                'contrastLightColors': undefined
            };
        }

        $mdThemingProvider.definePalette('warnPalette', getWarnPalette());

        // Für Angular-Theming
        if(window.ixaThemeConfig && typeof window.ixaThemeConfig === 'object'){
            var defaultTheme = {
                admin: getAdminPalette(),
                content: getContentPalette(),
                monitor: getMonitorPalette(),
                shop: getShopPalette(),
                system: getSystemPalette(),
                warn: getWarnPalette(),
                highContrast: getHighContrastPalette()
            };
            defaultTheme = angular.copy(defaultTheme);

            var themeConfigCopy = angular.copy(window.themeConfig);
            // ALLES übergeben, sonst könnten viele Style-Anpassungen 
            // in Angular zwischendurch gemacht werden.
            if(typeof window.ixaThemeConfig.setAllThemes === "function") {
                window.ixaThemeConfig.setAllThemes(
                    themeConfigCopy, 
                    defaultTheme, 
                    companyThemeConfigs,
                    {
                        background: getBackgroundPalette(),
                        warn: getWarnPalette()
                    }
                );
            } else {
                try {
                    console.error("ixaThemeConfig.setAllThemes not a function")
                }catch(e){}
            }
        }
    }
]);

function getShopPalette() {
    return {
        primary: {
            '50': '#e1e6ef',
            '100': '#b3c2d6',
            '200': '#8099bb',
            '300': '#4d709f',
            '400': '#27518b',
            '500': '#013276',
            '600': '#012d6e',
            '700': '#012663',
            '800': '#011f59',
            '900': '#001346',
            'A100': '#7a90ff',
            'A200': '#4766ff',
            'A400': '#143bff',
            'A700': '#002afa',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                'A100'
            ],
            'contrastLightColors': [
                '300',
                '400',
                '500',
                '600',
                '700',
                '800',
                '900',
                'A200',
                'A400',
                'A700'
            ]
        },
        accent: {
            '50': '#f9e5ea',
            '100': '#f0bdcb',
            '200': '#e691a8',
            '300': '#dc6585',
            '400': '#d5446a',
            '500': '#cd2350',
            '600': '#c81f49',
            '700': '#c11a40',
            '800': '#ba1537',
            '900': '#ae0c27',
            'A100': '#dc6585',
            'A200': '#cd2350',
            'A400': '#c81f49',
            'A700': '#c11a40',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                'A100'
            ],
            'contrastLightColors': [
                '400',
                '500',
                '600',
                '700',
                '800',
                '900',
                'A200',
                'A400',
                'A700'
            ]
        }
    };
}

function getContentPalette() {
    return {
        primary: {
            '50': '#e1efe4',
            '100': '#b3d6ba',
            '200': '#80bb8d',
            '300': '#4d9f5f',
            '400': '#278b3c',
            '500': '#01761a',
            '600': '#016e17',
            '700': '#016313',
            '800': '#01590f',
            '900': '#004608',
            'A100': '#4d9f5f',
            'A200': '#01761a',
            'A400': '#016e17',
            'A700': '#016313',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                'A100'
            ],
            'contrastLightColors': [
                '400',
                '500',
                '600',
                '700',
                '800',
                '900',
                'A200',
                'A400',
                'A700'
            ]
        },
        accent: {
            '50': '#fbede5',
            '100': '#f5d2be',
            '200': '#eeb492',
            '300': '#e79566',
            '400': '#e17f46',
            '500': '#dc6825',
            '600': '#d86021',
            '700': '#d3551b',
            '800': '#ce4b16',
            '900': '#c53a0d',
            'A100': '#e79566',
            'A200': '#dc6825',
            'A400': '#d86021',
            'A700': '#d3551b',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                '400',
                'A100'
            ],
            'contrastLightColors': [
                '500',
                '600',
                '700',
                '800',
                '900',
                'A200',
                'A400',
                'A700'
            ]
        }
    }
}

function getMonitorPalette() {
    return {
        primary: {
            '50': '#e5eef8',
            '100': '#bed5ef',
            '200': '#93bae4',
            '300': '#679ed9',
            '400': '#4789d0',
            '500': '#2674c8',
            '600': '#226cc2',
            '700': '#1c61bb',
            '800': '#1757b4',
            '900': '#0d44a7',
            'A100': '#679ed9',
            'A200': '#2674c8',
            'A400': '#226cc2',
            'A700': '#1c61bb',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                '400',
                'A100'
            ],
            'contrastLightColors': [
                '500',
                '600',
                '700',
                '800',
                '900',
                'A200',
                'A400',
                'A700'
            ]
        },
        accent: {
            '50': '#fbede5',
            '100': '#f5d2be',
            '200': '#eeb492',
            '300': '#e79566',
            '400': '#e17f46',
            '500': '#dc6825',
            '600': '#d86021',
            '700': '#d3551b',
            '800': '#ce4b16',
            '900': '#c53a0d',
            'A100': '#e79566',
            'A200': '#dc6825',
            'A400': '#d86021',
            'A700': '#d3551b',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                '400',
                'A100'
            ],
            'contrastLightColors': [
                '500',
                '600',
                '700',
                '800',
                '900',
                'A200',
                'A400',
                'A700'
            ]
        }
    };
}

function getAdminPalette() {
    return {
        primary: {
            '50': '#ececec',
            '100': '#d0d0d0',
            '200': '#b0b0b0',
            '300': '#909090',
            '400': '#797979',
            '500': '#616161',
            '600': '#595959',
            '700': '#4f4f4f',
            '800': '#454545',
            '900': '#333333',
            'A100': '#f39595',
            'A200': '#ee6868',
            'A400': '#ff2424',
            'A700': '#ff0a0a',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                'A100',
                'A200'
            ],
            'contrastLightColors': [
                '400',
                '500',
                '600',
                '700',
                '800',
                '900',
                'A400',
                'A700'
            ]
        },
        accent: {
            '50': '#fbede5',
            '100': '#f5d2be',
            '200': '#eeb492',
            '300': '#e79566',
            '400': '#e17f46',
            '500': '#dc6825',
            '600': '#d86021',
            '700': '#d3551b',
            '800': '#ce4b16',
            '900': '#c53a0d',
            'A100': '#e79566',
            'A200': '#dc6825',
            'A400': '#d86021',
            'A700': '#d3551b',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                '400',
                'A100'
            ],
            'contrastLightColors': [
                '500',
                '600',
                '700',
                '800',
                '900',
                'A200',
                'A400',
                'A700'
            ]
        }
    };
}

function getSystemPalette() {
    return {
        primary: {
            '50': '#f4e5e1',
            '100': '#e3bfb4',
            '200': '#d19482',
            '300': '#be694f',
            '400': '#b0492a',
            '500': '#a22904',
            '600': '#9a2403',
            '700': '#901f03',
            '800': '#861902',
            '900': '#750f01',
            'A100': '#be694f',
            'A200': '#a22904',
            'A400': '#9a2403',
            'A700': '#901f03',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200'
            ],
            'contrastLightColors': [
                '300',
                '400',
                '500',
                '600',
                '700',
                '800',
                '900',
                'A100',
                'A200',
                'A400',
                'A700'
            ]
        },
        accent: {
            '50': '#e5f2fb',
            '100': '#bedef5',
            '200': '#92c8ee',
            '300': '#66b1e7',
            '400': '#46a1e1',
            '500': '#2590dc',
            '600': '#2188d8',
            '700': '#1b7dd3',
            '800': '#1673ce',
            '900': '#0d61c5',
            'A100': '#66b1e7',
            'A200': '#2590dc',
            'A400': '#2188d8',
            'A700': '#1b7dd3',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                '400',
                'A100'
            ],
            'contrastLightColors': [
                '500',
                '600',
                '700',
                '800',
                '900',
                'A200',
                'A400',
                'A700'
            ]
        }
    };
}

function getHighContrastPalette() {
    return {
        primary: {
            '50': '#ffffff', <!-- Keep always white, Category selection (bbg) background -->
            '100': '#ffffff',
            '200': '#ffffff',
            '300': '#ffffff',
            '400': '#313131', <!-- background of certain comments (and search when unfocused in normal themes, customized to white (50) for highContrast) -->
            '500': '#000000', <!-- MAIN COLOR, Header color, background when not chosen, chosen page color, title fonts (very problematic), some icons, dialog header, etc. -->
            '600': '#8a8a8a', <!-- List number icon shade, chosen page shade -->
            '700': '#000000',
            '800': '#000000', <!-- Font color of workspace name (upper left corner) when chosen -->
            '900': '#000000',
            'A100': '#000000', <!-- List number icon -->
            'A200': '#000000',
            'A400': '#ffffff',
            'A700': '#ffffff',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                'A100',
                'A200'
            ],
            'contrastLightColors': [
                '400',
                '500',
                '600',
                '700',
                '800',
                '900',
                'A400',
                'A700'
            ]
        },
        accent: {
            '50': '#ffffff', <!-- Keep always white, Currently only custom for loading bar in high contrast specifically -->
            '100': '#ffffff',
            '200': '#ffffff',
            '300': '#ffffff',
            '400': '#ffffff',
            '500': '#cc0000', <!-- MAIN ACCENT, new button, checkbox, dialog confirm, etc. -->
            '600': '#000000',
            '700': '#2835d5', <!-- MAIN ACCENT SHADE -->
            '800': '#000000',
            '900': '#000000',
            'A100': '#ffffff', <!-- parallel to 400 -->
            'A200': '#cc0000', <!-- parallel to 500 -->
            'A400': '#000000', <!-- parallel to 600 -->
            'A700': '#2835d5', <!-- parallel to 700 -->
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                '400',
                'A100'
            ],
            'contrastLightColors': [
                '500',
                '600',
                '700',
                '800',
                '900',
                'A200',
                'A400',
                'A700'
            ]
        }
    };
}